// extracted by mini-css-extract-plugin
export default {"button":"button--XYfJB","button--active":"button--active--PK0tV"};